export default "__VITE_ASSET___N7yJ5C$__"